export default __webpack_public_path__ + "a0d5dd2ce78ad8fa1160b7223391061d.png";